import { Reveal, SectionHeading } from "@/components/motion";

const PILLARS = [
  { id: "truth", name: "Truth", desc: "A unified truth engine that compares planned vs actual vs claimed vs observed.", span: "lg:col-span-2" },
  { id: "verification", name: "Verification", desc: "Independent validation of every delivery event, regardless of the system that generated it.", span: "" },
  { id: "compliance", name: "Compliance", desc: "Regulatory-grade checks for geofencing, arrival windows, proximity rules, and audit requirements.", span: "" },
  { id: "auditability", name: "Auditability", desc: "Immutable event trails, signatures, and reconciliation logs for insurance and enterprise audit.", span: "lg:col-span-2" },
  { id: "anomaly", name: "Anomaly Detection", desc: "Automatic detection of suspicious behavior, deviations, or inconsistent telemetry.", span: "" },
  { id: "location", name: "Location Validation", desc: "High-precision WGS-84 validation of coordinates, movement, and event proximity.", span: "" },
  { id: "integrity", name: "Event Integrity", desc: "Ensures every event is legitimate, consistent, and compliant with operational truth.", span: "" },
];

const Pillars = () => (
  <section id="pillars" data-testid="value-pillars" className="border-b border-border">
    <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-24 lg:py-32">
      <SectionHeading index="04" eyebrow="Core Value Pillars" title="Proof, not assumptions." />
      <div className="mt-16 grid lg:grid-cols-3 border-t border-l border-border">
        {PILLARS.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.06} className={`${p.span} border-b border-r border-border`}>
            <div data-testid={`pillar-${p.id}`} className="group h-full p-8 lg:p-10 hover:bg-foreground transition-colors duration-300">
              <div className="flex items-baseline justify-between">
                <span className="font-mono text-xs text-muted-foreground group-hover:text-background/60 transition-colors duration-300">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className={`w-2 h-2 ${i === 4 ? "bg-anomaly" : "bg-truth"}`} />
              </div>
              <h3 className="font-display font-extrabold tracking-tight text-2xl mt-6 group-hover:text-background transition-colors duration-300">
                {p.name}
              </h3>
              <p className="text-sm text-muted-foreground leading-relaxed mt-3 group-hover:text-background/70 transition-colors duration-300">
                {p.desc}
              </p>
            </div>
          </Reveal>
        ))}
        <div className="hidden lg:flex border-b border-r border-border p-10 items-end bg-muted/40">
          <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-muted-foreground leading-loose">
            SEVEN SIGNALS
            <br />
            ONE VERDICT
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default Pillars;
